import React, { useState } from 'react';
import { Globe, ChevronDown, LogOut, ShieldCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const languages = ['English', 'Español', 'Français', 'Deutsch', '中文', 'हिन्दी'];

const UserBar = () => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const [lang, setLang] = useState('English');
  const [open, setOpen] = useState(false);

  const handleSignOut = () => {
    signOut();
    navigate('/');
  };

  if (!user) return null;

  return (
    <div className="w-full flex flex-wrap items-center justify-end gap-3 pt-6 pb-4 px-4 md:px-10">
      <div className="relative">
        <button
          onClick={() => setOpen(!open)}
          className="flex items-center gap-2 rounded-full border border-emerald-800/50 bg-emerald-950/40 px-4 py-2 text-sm text-emerald-100 hover:bg-emerald-900/50 transition"
        >
          <Globe size={16} className="text-emerald-400" />
          <span>{lang}</span>
          <ChevronDown size={14} className={`transition-transform ${open ? 'rotate-180' : ''}`} />
        </button>
        {open && (
          <div className="absolute right-0 mt-2 w-40 rounded-xl border border-emerald-900/60 bg-[#07160e] shadow-xl p-1.5 z-50">
            {languages.map((l) => (
              <button key={l} onClick={() => { setLang(l); setOpen(false); }} className="w-full text-left px-3 py-2 text-sm text-emerald-100/90 hover:bg-emerald-900/40 rounded-lg">{l}</button>
            ))}
          </div>
        )}
      </div>

      <div className="flex items-center gap-3 rounded-2xl border border-emerald-800/60 bg-gradient-to-r from-[#0b2418] via-[#0d2a1c] to-[#0b2418] pl-3 pr-2 py-2">
        <div className="inline-flex items-center gap-1.5 rounded-full bg-emerald-500/15 border border-emerald-700/60 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-emerald-300">
          <ShieldCheck size={12} /> {user.status}
        </div>
        <div className="leading-tight">
          <div className="text-sm font-medium text-white truncate max-w-[220px]">{user.displayName || user.email}</div>
          <div className="text-[11px] text-emerald-100/60">
            <span className="truncate inline-block max-w-[180px] align-middle">{user.email}</span>
            <span className="mx-1.5 text-emerald-100/30">•</span>
            <span>ID: <span className="text-emerald-300 font-medium">{user.memberId || user.id}</span></span>
          </div>
        </div>
        <button
          onClick={handleSignOut}
          className="ml-1 inline-flex items-center gap-1.5 rounded-xl bg-emerald-500 hover:bg-emerald-400 text-emerald-950 text-sm font-medium px-3 py-2 transition"
        >
          <LogOut size={14} /> Sign Out
        </button>
      </div>
    </div>
  );
};

export default UserBar;
